const schedule = [
  {
    date: { fulldate: "2023-03-11", day: "11", month: "MARÇO" },
    photo: "",
    description: "Manobras para Vida em Maringá (especial mulheres)",
  },
  {
    date: { fulldate: "2023-04-15", day: "15", month: "ABRIL" },
    photo: "",
    description: "Manobras para Vida em Cambira/Jandaia do Sul",
  },
  {
    date: { fulldate: "2023-05-20", day: "20", month: "MAIO" },
    photo: "",
    description: "Manobras para Vida em Londrina",
  },
  {
    date: { fulldate: "2023-06-17", day: "17", month: "JUNHO" },
    photo: "",
    description: "Manobras para Vida em Maringá",
  },
  {
    date: { fulldate: "2023-07-15", day: "15", month: "JULHO" },
    photo: "f7GQp32fJYCXb2y18",
    description: "Manobras para Vida em Cambira/Jandaia do Sul",
  },
  {
    date: { fulldate: "2023-08-12", day: "12", month: "AGOSTO" },
    photo: "LyCyeRAEVcwhx14W8",
    description: "Manobras para Vida em Londrina",
  },
  {
    date: { fulldate: "2023-09-02", day: "02", month: "SETEMBRO" },
    photo: "wHkpvtzcfbcc7viq6",
    description: "Manobras para Vida em Maringá",
  },
  {
    date: { fulldate: "2023-09-23", day: "23", month: "SETEMBRO" },
    photo: "",
    description: "Encerramento semana Nacional do Trânsito - Mandaguari",
  },
  {
    date: { fulldate: "2023-09-30", day: "30", month: "SETEMBRO" },
    photo: "aToNEdpWrzr9f6ME8",
    description: "Manobras para Vida em Cambira/Jandaia do Sul",
  },
  {
    date: { fulldate: "2023-10-12", day: "12", month: "OUTUBRO" },
    photo: "",
    description: "Evento dia das Crianças - Igreja Metodista em Cambira",
  },
  {
    date: { fulldate: "2023-10-21", day: "21", month: "OUTUBRO" },
    photo: "xTjRJN4rhfaAM4oKA",
    description: "Manobras para Vida em Londrina",
  },
  {
    date: { fulldate: "2023-10-28", day: "28", month: "OUTUBRO" },
    photo: "",
    description: "Comitiva para Guarapuava",
  },
  {
    date: { fulldate: "2023-11-11", day: "11", month: "NOVEMBRO" },
    photo: "qduoQjoTj4pht6fX8",
    description: "Manobras para Vida em Maringá",
  },
  {
    date: { fulldate: "2023-12-03", day: "03", month: "DEZEMBRO" },
    photo: "",
    description: "Confraternização de final de ano",
  },
];

export default schedule;
